/* eslint-disable @typescript-eslint/no-explicit-any */
import { DatePicker, Form } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

export function FormDate({
  id,
  name = "",
  label,
  type = "date",
  placeholder,
  required,
  widthSize = "large",
  rules,
  format,
  disabled = false,
  defaultValue = "",
  minDate = "",
  maxDate = "",
  ...rest
}: any) {
  dayjs.extend(customParseFormat);

  const dateFormat = "YYYY-MM-DD";

  const defaultValueDateConvert = defaultValue
    ? dayjs(defaultValue, dateFormat)
    : null;
  const minDateDateConvert = minDate ? dayjs(minDate, dateFormat) : null;
  const maxDateDateConvert = maxDate ? dayjs(maxDate, dateFormat) : null;

  const widthPercentage: string = (() => {
    switch (widthSize.toLowerCase()) {
      case "medium":
        return "75%";
      case "small":
        return "50%";
      default:
        return "100%";
    }
  })();
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      layout="vertical"

      // wrapperCol={{ span: 24 }}
    >
      <DatePicker
        //format={format}
        format={"DD-MM-YYYY"}
        {...rest}
        style={{ width: widthPercentage }}
        disabled={disabled}
        defaultValue={defaultValueDateConvert}
        minDate={minDateDateConvert}
        maxDate={maxDateDateConvert}
        placeholder={placeholder}
      />
    </Form.Item>
  );
}
